module.exports = "/_next/static/images/sudhanshu-b8a2f95ffc22f6ed2f647361a0fe66e9.png";